<template>
  <div id="contenedor-eliminar-contrato-insumo">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Insumo </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el insumo? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoInsumo"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixInsumosContrato from './mixInsumosContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarInsumoContrato',
  mixins: [mixInsumosContrato],
  props: {
    contratoInsumoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
